/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_BIRTHDAY_LIST = `${url}/LOAD_BIRTHDAY_LIST`;
export const LOAD_BIRTHDAY_LIST_SUCCESS = `${url}/LOAD_BIRTHDAY_LIST_SUCCESS`;
export const LOAD_BIRTHDAY_LIST_ERROR = `${url}/LOAD_BIRTHDAY_LIST_ERROR`;

export const LOAD_DASHBOARD_CHECKINOUT = `${url}/LOAD_DASHBOARD_CHECKINOUT`;
export const LOAD_DASHBOARD_CHECKINOUT_SUCCESS = `${url}/LOAD_DASHBOARD_CHECKINOUT_SUCCESS`;
export const LOAD_DASHBOARD_CHECKINOUT_ERROR = `${url}/LOAD_DASHBOARD_CHECKINOUT_ERROR`;

export const LOAD_DASHBOARD_ATTENDANCE = `${url}/LOAD_DASHBOARD_ATTENDANCE`;
export const LOAD_DASHBOARD_ATTENDANCE_SUCCESS = `${url}/LOAD_DASHBOARD_ATTENDANCE_SUCCESS`;
export const LOAD_DASHBOARD_ATTENDANCE_ERROR = `${url}/LOAD_DASHBOARD_ATTENDANCE_ERROR`;

export const LOAD_HOLIDAY_LIST = `${url}/LOAD_HOLIDAY_LIST`;
export const LOAD_HOLIDAY_LIST_SUCCESS = `${url}/LOAD_HOLIDAY_LIST_SUCCESS`;
export const LOAD_HOLIDAY_LIST_ERROR = `${url}/LOAD_HOLIDAY_LIST_ERROR`;

export const LOAD_YEARLY_LEAVE = `${url}/LOAD_YEARLY_LEAVE`;
export const LOAD_YEARLY_LEAVE_SUCCESS = `${url}/LOAD_YEARLY_LEAVE_SUCCESS`;
export const LOAD_YEARLY_LEAVE_ERROR = `${url}/LOAD_YEARLY_LEAVE_ERROR`;

export const LOAD_DAILY_PERCENTAGE_LIST = `${url}/LOAD_DAILY_PERCENTAGE_LIST`;
export const LOAD_DAILY_PERCENTAGE_LIST_SUCCESS = `${url}/LOAD_DAILY_PERCENTAGE_LIST_SUCCESS`;
export const LOAD_DAILY_PERCENTAGE_LIST_ERROR = `${url}/LOAD_DAILY_PERCENTAGE_LIST_ERROR`;

export const LOAD_WEEKLY_PERCENTAGE_LIST = `${url}/LOAD_WEEKLY_PERCENTAGE_LIST`;
export const LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS = `${url}/LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS`;
export const LOAD_WEEKLY_PERCENTAGE_LIST_ERROR = `${url}/LOAD_WEEKLY_PERCENTAGE_LIST_ERROR`;

export const LOAD_MONTHLY_PERCENTAGE_LIST = `${url}/LOAD_MONTHLY_PERCENTAGE_LIST`;
export const LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS = `${url}/LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS`;
export const LOAD_MONTHLY_PERCENTAGE_LIST_ERROR = `${url}/LOAD_MONTHLY_PERCENTAGE_LIST_ERROR`;

export const LOAD_EMPLOYEE_STATUS = `${url}/LOAD_EMPLOYEE_STATUS`;
export const LOAD_EMPLOYEE_STATUS_SUCCESS = `${url}/LOAD_EMPLOYEE_STATUS_SUCCESS`;
export const LOAD_EMPLOYEE_STATUS_ERROR = `${url}/LOAD_EMPLOYEE_STATUS_ERROR`;

export const LOAD_ATTENDANCE_OVERVIEW = `${url}/LOAD_ATTENDANCE_OVERVIEW`;
export const LOAD_ATTENDANCE_OVERVIEW_SUCCESS = `${url}/LOAD_ATTENDANCE_OVERVIEW_SUCCESS`;
export const LOAD_ATTENDANCE_OVERVIEW_ERROR = `${url}/LOAD_ATTENDANCE_OVERVIEW_ERROR`;

export const LOAD_DEPARTMENT = `${url}/LOAD_DEPARTMENT`;
export const LOAD_DEPARTMENT_SUCCESS = `${url}/LOAD_DEPARTMENT_SUCCESS`;
export const LOAD_DEPARTMENT_ERROR = `${url}/LOAD_DEPARTMENT_ERROR`;


export const LOAD_ATTENDANCE_OVERVIEW_TODAY = `${url}/LOAD_ATTENDANCE_OVERVIEW_TODAY`;
export const LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS = `${url}/LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS`;
export const LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR = `${url}/LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR`;

export const LOAD_ATTENDANCE_OVERVIEW_THISWEEK = `${url}/LOAD_ATTENDANCE_OVERVIEW_THISWEEK`;
export const LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS = `${url}/LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS`;
export const LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR = `${url}/LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR`;

export const LOAD_ATTENDANCE_OVERVIEW_THISMONTH = `${url}/LOAD_ATTENDANCE_OVERVIEW_THISMONTH`;
export const LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS = `${url}/LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS`;
export const LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR = `${url}/LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR`;

export const LOAD_LATE = `${url}/LOAD_LATE`;
export const LOAD_LATE_SUCCESS = `${url}/LOAD_LATE_SUCCESS`;
export const LOAD_LATE_ERROR = `${url}/LOAD_LATE_ERROR`;

export const LOAD_EMPLOYEE_TYPE = `${url}/LOAD_EMPLOYEE_TYPE`;
export const LOAD_EMPLOYEE_TYPE_SUCCESS = `${url}/LOAD_EMPLOYEE_TYPE_SUCCESS`;
export const LOAD_EMPLOYEE_TYPE_ERROR = `${url}/LOAD_EMPLOYEE_TYPE_ERROR`;

const constants = {
  LOAD_BIRTHDAY_LIST,
  LOAD_BIRTHDAY_LIST_SUCCESS,
  LOAD_BIRTHDAY_LIST_ERROR,

  LOAD_DASHBOARD_CHECKINOUT,
  LOAD_DASHBOARD_CHECKINOUT_SUCCESS,
  LOAD_DASHBOARD_CHECKINOUT_ERROR,

  LOAD_DASHBOARD_ATTENDANCE,
  LOAD_DASHBOARD_ATTENDANCE_SUCCESS,
  LOAD_DASHBOARD_ATTENDANCE_ERROR,

  LOAD_HOLIDAY_LIST,
  LOAD_HOLIDAY_LIST_SUCCESS,
  LOAD_HOLIDAY_LIST_ERROR,

  LOAD_YEARLY_LEAVE,
  LOAD_YEARLY_LEAVE_SUCCESS,
  LOAD_YEARLY_LEAVE_ERROR,

  LOAD_DAILY_PERCENTAGE_LIST,
  LOAD_DAILY_PERCENTAGE_LIST_SUCCESS,
  LOAD_DAILY_PERCENTAGE_LIST_ERROR,

  LOAD_WEEKLY_PERCENTAGE_LIST,
  LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS,
  LOAD_WEEKLY_PERCENTAGE_LIST_ERROR,

  LOAD_MONTHLY_PERCENTAGE_LIST,
  LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS,
  LOAD_MONTHLY_PERCENTAGE_LIST_ERROR,

  LOAD_EMPLOYEE_STATUS,
  LOAD_EMPLOYEE_STATUS_SUCCESS,
  LOAD_EMPLOYEE_STATUS_ERROR,

  LOAD_ATTENDANCE_OVERVIEW,
  LOAD_ATTENDANCE_OVERVIEW_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_ERROR,

  LOAD_ATTENDANCE_OVERVIEW_TODAY,
  LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR,

  LOAD_ATTENDANCE_OVERVIEW_THISWEEK,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR,

  LOAD_ATTENDANCE_OVERVIEW_THISMONTH,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_DEPARTMENT,
  LOAD_DEPARTMENT_SUCCESS,
  LOAD_DEPARTMENT_ERROR,

  LOAD_LATE,
  LOAD_LATE_SUCCESS,
  LOAD_LATE_ERROR,

  LOAD_EMPLOYEE_TYPE,
  LOAD_EMPLOYEE_TYPE_SUCCESS,
  LOAD_EMPLOYEE_TYPE_ERROR
};

export default constants;
